/**
 * 监测区间国际化
 * date：2022 03 07
 */
 export default {
    detection:{
        mInterval:'Monitoring Range',
        unitMeasurement:'Measurement Unit',
        intervalValue:'Range Values',
        onlyNumber:'Please enter a numeric value with no more than two decimal places.',
        minMax:'The lower limit cannot exceed the upper limit.',
        notMinEmpty:'The lower limit is required.',
        notMaxEmpty:'The upper limit is required.',
        UOMnotEmpty:'Unit of measurement is required.',
        notEmpty:'Range Values  are required.',
        addInterval:'Add Monitoring Range',
        edit:'Edit',
        monitoringInterval:'Monitoring Range',
        maxLimit: 'Maximum Value cannot exceed.'
    }
}